// src/components/registration/RegisterHeroUserConsole.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import StepWelcome from "./steps/StepWelcome";
import StepCompanySetup from "./steps/StepCompanySetup"; // Import StepCompanySetup
import StepAddUserGroups from "./steps/StepAddUserGroups"; // Import StepAddUserGroups
import UserGroupsWizard from "./steps/supportComponents/userGroupSteps/UserGroupsWizard"; // Import UserGroupsWizard
import StepSystemPermissions from "./steps/StepSystemPermissions";
// Import additional steps as needed

const RegisterHeroUserConsole = () => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(1); // Holds the current step ID
  const [previousStep, setPreviousStep] = useState(null); // Holds the previous step ID

  // State to store data from StepWelcome
  const [setupData, setSetupData] = useState({
    userEmail: "",
    company: "",
    collectionBrand: "",
    systemName: "",
  });

  // Function to navigate to the next step and capture data
  const goToNextStep = (data) => {
    if (data) {
      setSetupData(data);
    }
    if (currentStep === 4) {
      // If we're at step 4, we navigate to /hero-dashboard
      navigate("/hero-dashboard");
    } else {
      setCurrentStep((prevStep) => prevStep + 1);
    }
  };

  // Function to navigate to the previous step
  const goToPreviousStep = () => {
    setCurrentStep((prevStep) => (prevStep > 1 ? prevStep - 1 : prevStep));
    setPreviousStep(currentStep);
  };

  // Define the steps in an array for easy management
  const steps = [
    {
      id: 1,
      name: "Welcome",
      component: <StepWelcome onContinue={goToNextStep} />, // Pass the onContinue prop
    },
    {
      id: 2,
      name: "Company Setup",
      component: (
        <StepCompanySetup
          onContinue={goToNextStep} // Ensure onContinue is passed
          userEmail={setupData.userEmail}
          company={setupData.company}
          collectionBrand={setupData.collectionBrand}
          systemName={setupData.systemName}
        />
      ), // Pass the setupData as props
    },
    {
      id: 3,
      name: "Add User Groups",
      component: (
        <UserGroupsWizard
          onContinue={goToNextStep}
          userEmail={setupData.userEmail}
          company={setupData.company}
          collectionBrand={setupData.collectionBrand}
        />
      ), // Add StepAddUserGroups
    },
    {
      id: 4,
      name: "System Permissions",
      component: (
        <StepSystemPermissions
          onContinue={goToNextStep}
          userEmail={setupData.userEmail}
          company={setupData.company}
          collectionBrand={setupData.collectionBrand}
        />
      ),
    },
    // Add additional steps here
  ];

  // Function to render the current step component
  const renderStep = () => {
    const step = steps.find((s) => s.id === currentStep);
    return step ? step.component : <StepWelcome onContinue={goToNextStep} />;
  };

  return (
    <div className="register-console-container">
      <div className="register-steps"></div>
      <div className="register-step-content">{renderStep()}</div>
      <div className="registration-navigation">
        {/* {currentStep > 1 && (
          <button
            type="button"
            className="action-button"
            onClick={goToPreviousStep}
          >
            Back
          </button>
        )} */}
      </div>
    </div>
  );
};

export default RegisterHeroUserConsole;
